<template>
    <div>
        ログアウトしています。
    </div>
</template>
      
<script>
    export default {

        beforeMount() {
            //【cognito】
            this.$cognito.signout()
            //this.$store.commit('resetState')
            //this.$router.push('/')
            //this.$router.go(this.$router.currentRoute.path)

            setTimeout(this.resetStorage,100)

            //this.$cognito.signout()
            //    .then(result => {
            //        console.log("nakami")
            //        console.log(result)
            //        this.$store.commit('resetState')
            //        this.$router.push('/')
            //    })
            //    .catch(err => {
            //        console.log("era-erap")
            //        console.log(err)
            //    })
        },

        methods: {
            resetStorage() {
                this.$store.commit('resetState')
                this.$router.push('/')
                this.$router.go(this.$router.currentRoute.path)
            }
        }
    }
</script>
      
<style>
</style>
      